//React
import React, { useContext, useEffect, useState } from "react";

//Material
import { Container, FormControlLabel, Grid, Switch } from "@material-ui/core";
import { Add, EditOutlined } from "@material-ui/icons";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { useHistory } from "react-router";

//OurComponents
import HeaderModule from "../../../components/header/HeaderModule";
import TextFieldErp from "../../../components/basics/TextFieldErp";

//Styles
import { PainelContainer } from "./styles/Intermediador";
import Btn from "../../../components/buttons/Btn";
import { TableContent } from "../../prouser/clientes/styles/Cliente";
import BigDataTable from "../../../components/tables/BigDataTable";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import { BallContainer } from "./styles/Intermediador";
import RedBall from "../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../assets/imgs/bolinha-verde.png";
import { IntermediadorContextProvider } from "./contexts/IntermediadorContext";

let typingTimer = null;
const View = ({ ...props }) => {
  // const useState
  const [ativo, setAtivo] = useState(true);
  const [textFilter, setTextFilter] = useState("");
  const [queryOrWhere, setQueryOrWhere] = useState(null);
  const [queryWhere, setQueryWhere] = useState({ ativo: "" });
  const { push } = useHistory();
  const { queryParams } = useContext(QueryParamsContext);

  const defaultTableColumns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        return (
          <SpeedDialErp
            actions={[
              {
                icon: <EditOutlined />,
                name: "Editar",
                action: () =>
                  push("cadastro?empresa_cnpj=" + queryParams.empresa_cnpj, {
                    item,
                  }),
              },
            ]}
          />
        );
      },
    },
    {
      id: "id",
      label: "ID",
    },
    {
      id: "razao",
      label: "Razão Social",
    },
    {
      id: "descricao",
      label: "Descrição",
    },
    {
      id: "cnpj",
      label: "CNPJ",
    },
    {
      id: "intermediador",
      label: "Intermediador",
      format: (item) => {
        return item.intermediador ? "SIM" : "NÃO";
      },
    },
    {
      id: "ativo",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.ativo === 1 ? (
          <BallContainer>
            <img src={GreenBall} alt="Intermediador ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="Intermediador inativo" />
          </BallContainer>
        ),
    },
  ];

  // Funções de eventos
  const ativoOnChange = (e) => {
    setAtivo(e.target.checked);
  };

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setQueryOrWhere({
        razao: encodeURIComponent(`${textFilter}`),
        descricao: encodeURIComponent(`${textFilter}`),
        cnpj: `${textFilter || null}`,
      });
    }, 1500);
  }, [textFilter]);

  useEffect(() => {
    setQueryWhere({ ativo: ativo ? "1" : "0" });
  }, [ativo]);

  return (
    <>
      <HeaderModule title="CADASTRO DE INTERMEDIADOR / MARKETPLACE" />

      <PainelContainer />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid
            item
            container
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <Grid item xs={12} sm={12} md={7}>
              <TextFieldErp
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por Razão, Descrição ou CNPJ"
                variant="filled"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={ativo}
                    onChange={ativoOnChange}
                    color="primary"
                    name="ativo"
                  />
                }
                label="Ativos"
                labelPlacement="end"
              />
            </Grid>

            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<Add />}
                onClick={() => push("cadastro")}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TableContent>
              <BigDataTable
                tableTitle=""
                route="vendas/origem/v1"
                columns={defaultTableColumns}
                include="localEstoque"
                filter={{
                  "vendas.origem": "id,razao,descricao,intermediador,ativo",
                }}
                where={queryWhere}
                orWhere={queryOrWhere}
                reload={false}
              />
            </TableContent>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

const IntermediadorView = ({ ...props }) => (
  <IntermediadorContextProvider>
    <View {...props} />
  </IntermediadorContextProvider>
);

export default IntermediadorView;
